import React from 'react';

interface AttachmentListIconProps {
  color?: string;
  height?: number | string;
  width?: number | string;
  opacity?: number;
  style?: React.CSSProperties;
  className?: string;
  'aria-label'?: string;
}

const AttachmentListIcon: React.FC<AttachmentListIconProps> = ({
  color = '#2372B9',
  height = 20,
  width = 20,
  opacity = 1,
  style,
  className,
  'aria-label': ariaLabel,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={height}
    width={width}
    viewBox="0 0 20 20"
    style={{ opacity, ...style }}
    className={className}
    aria-label={ariaLabel}
    role={ariaLabel ? 'img' : 'presentation'}
    fill="none"
  >
    <path
      d="M9.0187 2.4002C10.775 0.643945 13.625 0.643945 15.3812 2.4002C17.1375 4.15645 17.1375 7.00644 15.3812 8.76269L10.2562 13.8877C9.1812 14.9627 7.44058 14.9627 6.36558 13.8877C5.29058 12.8127 5.29058 11.0721 6.36558 9.99707L11.1406 5.22832C11.5312 4.8377 12.1656 4.8377 12.5562 5.22832C12.9468 5.61895 12.9468 6.25332 12.5562 6.64395L7.7812 11.4158C7.48745 11.7096 7.48745 12.1846 7.7812 12.4752C8.07495 12.7658 8.54995 12.7689 8.84058 12.4752L13.9656 7.35019C14.9406 6.3752 14.9406 4.79082 13.9656 3.81582C12.9906 2.84082 11.4062 2.84082 10.4312 3.81582L5.3062 8.94082C3.64683 10.6002 3.64683 13.2908 5.3062 14.9502C6.96558 16.6096 9.6562 16.6096 11.3156 14.9502L15.3843 10.8846C15.775 10.4939 16.4093 10.4939 16.8 10.8846C17.1906 11.2752 17.1906 11.9096 16.8 12.3002L12.7312 16.3627C10.2906 18.8033 6.33433 18.8033 3.8937 16.3627C1.45308 13.9221 1.45308 9.96582 3.8937 7.5252L9.0187 2.4002Z"
      fill={color}
    />
  </svg>
);

export default AttachmentListIcon;
